import React from 'react';
import styled from 'styled-components';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';

const Text = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: block; ;
`;

const Bold = styled.div`
  font-weight: 500;
`;

const Accent = styled.span`
  color: #fcc475;
`;

const TextWithIcon = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const IconContainer = styled.div`
  width: 18px;
  height: 18px;
  svg {
    fill: var(--accent500);
  }
`;

const SoSpecialIntructionsTooltip = ({ className }) => {
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <Text>
        <Bold>
          <Accent>{t('complements.special_instructions_tooltip.line1')}</Accent>
        </Bold>
      </Text>
      <Text>{t('complements.special_instructions_tooltip.line2')}</Text>
      <Text>
        <Bold>
          <Accent>{t('complements.special_instructions_tooltip.line3')}</Accent>
        </Bold>
      </Text>
      <Text>{t('complements.special_instructions_tooltip.line4')}</Text>
      <TextWithIcon>
        <IconContainer>
          <Icon glyph="handling" size={'18px'} />
        </IconContainer>
        <Text>{t('complements.special_instructions_tooltip.line5')}</Text>
      </TextWithIcon>
      <TextWithIcon>
        <IconContainer>
          <Icon glyph="handling" size={'18px'} />
        </IconContainer>
        <Text>{t('complements.special_instructions_tooltip.line6')}</Text>
      </TextWithIcon>
      <TextWithIcon>
        <IconContainer>
          <Icon glyph="handling" size={'18px'} />
        </IconContainer>
        <Text>{t('complements.special_instructions_tooltip.line7')}</Text>
      </TextWithIcon>
      <TextWithIcon>
        <IconContainer>
          <Icon glyph="handling" size={'18px'} />
        </IconContainer>
        <Text>
          {t('complements.special_instructions_tooltip.line8')}{' '}
          <Accent>{t('complements.special_instructions_tooltip.line9')}</Accent>
        </Text>
      </TextWithIcon>
      <Text>{t('complements.special_instructions_tooltip.line10')}</Text>
    </div>
  );
};

export default styled(SoSpecialIntructionsTooltip)`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 12px;
`;
